import type { SvgIconProps } from '@mui/material';

import type { PatientIntakeStep } from '@shared/patient-intake-status';

import { BaseStepIcon } from './BaseStepIcon.tsx';
import { CustomStepIcon } from './CustomStepIcon.tsx';

const throwNever = (status: never) => {
  throw new Error(`Status does not exist: ${status}`);
};

interface StepIconProps extends SvgIconProps {
  step: PatientIntakeStep;
}

export const StepIcon = ({ step, ...iconProps }: StepIconProps) => {
  if (step.stepType === 'BASE_STEP') {
    return <BaseStepIcon step={step} {...iconProps} />;
  }

  if (step.stepType === 'CUSTOM_STEP') {
    return <CustomStepIcon customStepType={step.type} status={step.currentStatus?.status} {...iconProps} />;
  }

  return throwNever(step);
};
